const parallaxStyle = theme => ({
  parallax: {
    maxHeight: "400px",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '10px'
    }
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.0)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  small: {
    
  }
});

export default parallaxStyle;
